import { Routes } from '@angular/router';
import { UserManagementComponent } from 'src/core/components/users/user-management.component';
import { adminGuard } from '../../guards/admin.guard';

export const usersRoutes: Routes = [
  {
    canMatch: [adminGuard],
    path: '',
    component: UserManagementComponent,
  },
];
